import { useFormTextContext } from './FormTextContext';
export const useTextInputVariantProps = (props) => {
    const { setFocused, setHovered } = useFormTextContext({});
    return {
        onFocus: (e) => {
            var _a;
            setFocused(true);
            (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onBlur: (e) => {
            var _a;
            setFocused(false);
            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onMouseEnter: (e) => {
            var _a;
            setHovered(true);
            (_a = props.onMouseEnter) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onMouseLeave: (e) => {
            var _a;
            setHovered(false);
            (_a = props.onMouseLeave) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
    };
};
export const useTextAreaVariantProps = (props) => {
    const { setFocused, setHovered } = useFormTextContext({});
    return {
        onFocus: (e) => {
            var _a;
            setFocused(true);
            (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onBlur: (e) => {
            var _a;
            setFocused(false);
            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onMouseEnter: (e) => {
            var _a;
            setHovered(true);
            (_a = props.onMouseEnter) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
        onMouseLeave: (e) => {
            var _a;
            setHovered(false);
            (_a = props.onMouseLeave) === null || _a === void 0 ? void 0 : _a.call(props, e);
        },
    };
};
export const useFormTextStateProps = (params) => {
    const state = useFormTextContext(params);
    return {
        $isFocused: state.isFocused,
        $isHovered: state.isHovered,
        $hasError: state.hasError,
        $isDisabled: state.isDisabled,
    };
};
//# sourceMappingURL=useFormTextContextProps.js.map